import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { UiIconsModule } from 'ui-icons';

import { TaskManagementMenuItem } from './task-management-navigation-menu.model';

@Component({
  selector: 'ui-platform-task-management-navigation-menu',
  templateUrl: './task-management-navigation-menu.component.html',
  styleUrl: './task-management-navigation-menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzAnchorModule,
    UiIconsModule,
    TranslocoPipe,
    NzMenuModule,
    RouterModule,
    UpperCasePipe
  ]
})
export class TaskManagementNavigationMenuComponent implements OnChanges {
  #router = inject(Router);

  @Input() navigationItems: TaskManagementMenuItem[] | null = null;
  @Input() currentPage: string | undefined;
  @Input() currentFramework: string | null | undefined;
  @Input() currentYear: number | null | undefined;

  openMap: Record<number, boolean> = {};

  ngOnChanges(changes: SimpleChanges): void {
    const inputsChanged = changes['navigationItems'] || changes['currentPage'] || changes['currentFramework'] || changes['currentYear'];

    if (inputsChanged && this.navigationItems) {
      this.#updateOpenMap();
    }
  }

  openHandler(clickedIndex: number): void {
    const wasOpen = this.openMap[clickedIndex];
    const newOpenMap: Record<number, boolean> = {};

    if (!wasOpen) {
      newOpenMap[clickedIndex] = true;
    }

    this.openMap = newOpenMap;

    if (!wasOpen) {
      this.#navigateToSelectedItem(clickedIndex);
    }
  }

  trackParent(_index: number, parent: TaskManagementMenuItem): string {
    return `${parent.label}-${parent.year}`;
  }

  trackChild(_index: number, child: TaskManagementMenuItem): string {
    return `${child.page?.framework}-${child.page?.year}-${child.page?.subpage}`;
  }

  #updateOpenMap(): void {
    const newOpenMap: Record<number, boolean> = {};
    const activeParentIndex = (this.navigationItems ?? []).findIndex(parent => parent.label === this.currentFramework && parent.year === this.currentYear);

    if (activeParentIndex > -1) {
      newOpenMap[activeParentIndex] = true;
    } else if ((this.navigationItems?.length ?? 0) > 0) {
      newOpenMap[0] = true;
    }
    this.openMap = newOpenMap;
  }

  #navigateToSelectedItem(index: number): void {
    if (this.navigationItems) {
      const activeItem = this.navigationItems[index];
      const firstChildOfActiveItem = activeItem?.children?.[0];

      if (firstChildOfActiveItem?.page) {
        this.#router.navigate([], {
          queryParams: {
            profile: firstChildOfActiveItem.page.profile,
            framework: firstChildOfActiveItem.page.framework,
            year: firstChildOfActiveItem.page.year,
            subpage: firstChildOfActiveItem.page.subpage
          },
          queryParamsHandling: 'merge'
        });
      }
    }
  }
}
